module.exports = __webpack_public_path__ + "img/13.3aa12691.jpg";